export default __webpack_public_path__ + "f43495898d490e65c491f57c5afed8a5.svg";